import { Preferences, UserPreferences } from '@/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAskBluejApiContext } from '../api/context';

export function useUpdateUserPreferencesQuery() {
  const { api } = useAskBluejApiContext();
  const queryClient = useQueryClient();

  const mutation = useMutation<UserPreferences, unknown, Partial<Preferences>>({
    mutationFn: async (data) => {
      return api.updateUserPreferences(data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['preferences'] })
    }
  });

  function updateUserPreferences(data: Partial<Preferences>) {
    return mutation.mutateAsync(data);
  }

  return {
    updateUserPreferences
  }
}
